import { MessageCircle, Phone, Instagram, MapPin, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { waLink } from "../../lib/content";
import { useLang, txt } from "../../lib/i18n";

const Item = ({ href, icon: Icon, label, value, testid }) => (
  <a href={href} target="_blank" rel="noreferrer" data-testid={testid}
    className="group flex items-center justify-between border-t border-white/[0.08] py-5 transition-colors hover:text-accent">
    <span className="flex items-center gap-4">
      <Icon size={20} className="text-accent2" />
      <span>
        <span className="block font-mono text-[11px] uppercase tracking-[0.22em] text-zinc-400">{label}</span>
        <span className="block text-lg font-semibold text-white group-hover:text-accent">{value}</span>
      </span>
    </span>
    <ArrowUpRight size={18} className="text-zinc-500 transition-transform group-hover:-translate-y-0.5 rtl:-scale-x-100" />
  </a>
);

export const Contact = ({ contact, pricing }) => {
  const { t, lang, pick } = useLang();
  const wa = waLink(contact, "", lang);
  return (
  <section id="contact" className="relative overflow-hidden border-t border-white/[0.07]" data-testid="contact-section">
    <div aria-hidden="true" className="absolute -start-40 top-20 h-[420px] w-[420px] rounded-full bg-accent2/20 blur-[120px]" />
    <div className="relative mx-auto grid max-w-[1440px] gap-12 px-5 py-24 lg:grid-cols-12 lg:px-10 lg:py-32">
      <Reveal className="lg:col-span-7">
        <p className="mb-4 flex items-center gap-3 font-mono text-sm uppercase tracking-[0.22em] text-zinc-300 sm:text-[15px]"><span className="h-px w-10 shrink-0 bg-accent2" /> {t.bookEyebrow}</p>
        <h2 className="font-display text-[2.1rem] font-bold uppercase leading-[0.95] tracking-[-0.02em] text-white sm:text-6xl lg:text-7xl">
          {t.bookTitle[0]}<br />{t.bookTitle[1]}<span className="text-accent">{t.bookTitle[2]}</span>
        </h2>
        <p className="mt-6 max-w-lg text-base leading-relaxed text-zinc-300">
          {txt(t.bookText, pricing.free_trial)}
        </p>
        <a href={wa} target="_blank" rel="noreferrer" data-testid="whatsapp-book-trial-cta"
          className="mt-8 inline-flex items-center gap-3 rounded-full bg-accent px-8 py-4 text-lg font-bold text-onaccent transition-transform hover:-translate-y-1 active:scale-95">
          <MessageCircle size={22} /> {t.bookOnWa}
        </a>
      </Reveal>
      <Reveal className="lg:col-span-5 lg:pt-10" delay={0.1}>
        <Item href={wa} icon={MessageCircle} label={t.whatsapp} value={<span dir="ltr">{contact.phone}</span>} testid="contact-whatsapp-link" />
        <Item href={`tel:${contact.phone.replace(/\s/g, "")}`} icon={Phone} label={t.call} value={<span dir="ltr">{contact.phone}</span>} testid="contact-phone-link" />
        <Item href={contact.instagram} icon={Instagram} label={t.instagram} value={<span dir="ltr">@{(contact.instagram || "").replace(/\/+$/, "").split("/").pop()}</span>} testid="instagram-link" />
        <Item href={contact.map_url} icon={MapPin} label={t.studio} value={pick(contact, "location")} testid="contact-location-link" />
        <div className="border-t border-white/[0.08]" />
      </Reveal>
    </div>
  </section>
  );
};
